// extracted by mini-css-extract-plugin
export default {"otoczka":"AkcjaZPowodem_otoczka__mdIDQ","odnosnik":"AkcjaZPowodem_odnosnik__6SiJ1","powod":"AkcjaZPowodem_powod__jcBFw","coZrobic":"AkcjaZPowodem_coZrobic__ZF0ne"};